<template>
    <div>
        <b-card no-body >
			<div class="row mt-3 mb-3 pl-4">
				<!-- <div
					class="col-md-6"
					:class="mobile ? 'order-1 mb-3' : 'order-2 text-right'"
				>
					<button
						type="button"
						class="btn btn-sm btn-primary"
						@click="$router.push('/work-order-form')"
					>
						< Kembali
					</button>
				</div> -->
				<div class="col-md-6" :class="mobile ? 'order-2' : 'order-1'">
					
					<h2><i class="fa fa-arrow-left" @click="$router.go(-1)" style="cursor:pointer"></i><span class="ml-3">Estimasi Pembelian Parts</span></h2>
				</div>
			</div>
		</b-card>

        <div
			class="row mt-2"
            v-if="woDetail"
		>
			<div class="col-md-12 h-100">
				<b-card no-body class="p-10">
					<div class="row mt-2">
						<div class="col-9 mt-auto mb-auto">
							<h4 class="ml-2 mr-2" style="text-decoration-line: underline;text-underline-offset: 6px;">Nomor Work Order : {{formCode}}</h4>
						</div>
					</div>
					
					<div class="row mt-3 pl-2 pr-2">
						<div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Nama Pelanggan
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.customer.name
									}} ({{woDetail.customer.alias}})</b>
								</div>
							</div>
                        </div>
                        <div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Nomor Kontak
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.customer.phone_number
									}}</b>
								</div>
							</div>
                        </div>
                    </div>
                    <div class="row mb-4 mt-3 pl-2 pr-2">
						<div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Alamat
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.customer.address
									}}</b>
								</div>
							</div>
                        </div>
                        <div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Email
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{
										woDetail.customer.email
									}}</b>
								</div>
							</div>
                        </div>
                    </div>

					<div class="row">
						<div class="col-3 offset-9">
							<button
								class="btn btn-danger w-100"
								@click="cancelWorkOrder(null)"
							>
								Batalkan Work Order
							</button>
						</div>
					</div>
                </b-card>
            </div>
        </div>

		<div
			class="row mt-2"
            v-if="woDetail"
		>
			<div class="col-md-12 h-100">
				<b-card no-body class="p-10">
					<h4 class="mt-2 ml-2 mr-2" style="text-decoration-line: underline;text-underline-offset: 6px;">Data Deskripsi Mobil</h4>
					<div class="row mt-3 pl-2 pr-2">
						<div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Merek Mobil
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									<b>
										{{woFull.model ? woFull.model.name : '-'}}
									</b>
								</div>
							</div>
                        </div>
                        <div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Warna Mobil
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>
										{{woFull.colour ? woFull.colour.name : '-'}} 
									</b>
								</div>
							</div>
                        </div>
                    </div>
                    <div class="row mt-3 pl-2 pr-2">
						<div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Nomor Rangka
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{woFull.chassis_number ? woFull.chassis_number : '-'}}</b>
								</div>
							</div>
                        </div>
                        <div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Nomor Mesin
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{woFull.engine_number ? woFull.engine_number : '-'}}</b>
								</div>
							</div>
                        </div>
                    </div>
					<div class="row mb-4 mt-3 pl-2 pr-2">
						<div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Nomor Polisi
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{woFull.registration ? woFull.registration : '-'}}</b>
								</div>
							</div>
                        </div>
                        <div class="col-md-6" style="font-size:14px;">
							<div class="row">
								<div class="col-5 mt-1">
									Tahun Mobil
								</div>
								<div class="col-md-1 mt-1">
									:
								</div>
								<div class="col-6 mt-1">
									
									<b>{{woFull.year ? woFull.year : '-'}}</b>
								</div>
							</div>
                        </div>
                    </div>
                </b-card>
            </div>
        </div>

        <div class="row mt-3 mb-3">
            <div
                class="offset-6 col-6 w-100 mt-2 "
                
            >
                <button
                    class="btn btn-primary w-100"
                    @click="addNewSparePart()"
                >
                    Tambah Sparepart
                </button>
            </div>
        </div>

        <div class="w-100 mt-3">
            <b-card no-body v-if="estimationData">
                <!-- {{estimationData}} -->
                <individual-row-estimation
                    
                    v-for="estimationPart in estimationData.estimations"
                    :estimationPart="estimationPart"
                    :supplierPriceList="supplierPriceList"
                    :noEstimation="true"
					:noSetHarga="true"
                    @showPriceModal="showPriceModal"
					@loadEstimation="loadEstimation"
                />
            </b-card>
        </div>

        <!-- Pricing -->

        <b-card no-body @click="showPricingDetail = !showPricingDetail" class="mt-3">
			<div class=" pt-2 text-center mt-2 mb-2 row ml-3 mr-3">
				<div class="col-6 text-left">
					<h4>Liat Perincian Harga</h4>
				</div>
				<div class="col-6 text-right">
					<h4>
						<i class="fa fa-angle-double-down" v-if="!showPricingDetail"></i>
						<i class="fa fa-angle-double-up" v-else></i>
					</h4>
				</div>
			</div>
		</b-card>

        <b-card no-body v-if="estimationData">
			<div
				class="row w-100 mt-4 ml-3 mr-3"
				v-if="estimationData && showPricingDetail"
				style="font-size:14px;"
				:class="{ cancelled: woFull.deleted_at }"
			>
				
				<div
					class="col-12 mt-2"
				>
					<h4>Rincian Harga</h4>
					<table class="table wo-stats" v-if="!mobile">
						<tr>
							<!-- <td>Total Jasa</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.totalJasa
									)
								}}
							</td> -->
							<td>Total Part</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.totalPart
									)
								}}
							</td>
                            <td>Diskon Part</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.discount_part
									)
								}}
							</td>
						</tr>
						<tr>
							<!-- <td>Diskon Jasa</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.discount
									)
								}}
							</td> -->
						</tr>
						<tr>
							<td>Total Discount</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.discount
										) +
											parseFloat(
												this.estimationData.details
													.discount_part
											)
									)
								}}
							</td>
							<td>PPN
								<i class="fa fa-info-circle" id="averageTime"></i>
								<b-popover target="averageTime" title="Perincian Harga PPN" triggers="hover focus" placement="bottom" >
									<!-- <span v-html="singleRow.content"></span> -->

									<table class="table table-bordered text-center">
										<thead class="thead-dark">
											<th>Nama J / P</th>
											<th>Harga PPN</th>
										</thead>
										<tbody v-for="estimation in estimationData.estimations">
											<tr>
												<td>{{estimation.alias}} - {{estimation.part_number}}</td>
												<td>{{
													estimation.without_ppn ? 
													'Harga Sudah Termasuk PPN' : 
													'Rp. ' + numberWithCommas(
														estimation.individual_ppn ? estimation.individual_ppn : 0
													)
												}}</td>
											</tr>
										</tbody>
									</table>
								</b-popover>

							</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(this.estimationData.details.ppn)
									)
								}}
							</td>
							
						</tr>
						<tr style="font-weight:bold;border-bottom:1px solid black">
							<td colspan="3">Bruto Net Total</td>
							<td colspan="2"></td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.totalJasa
										) +
										parseFloat(
											this.estimationData.details.totalPart
										) -
										parseFloat(
											this.estimationData.details.discount
										) -
											parseFloat(
												this.estimationData.details
													.discount_part
											)
										+ parseFloat(this.estimationData.details.ppn)
											
									)
								}}
							</td>
							<!-- <td>Total Discount Part</td>
							<td>:</td>
							<td>Rp {{numberWithCommas(this.estimationData.details.totalPart * ( this.estimationData.details.discount / 100))}} ({{this.estimationData.details.discount}}%)</td> -->
						</tr>
						<tr>
							<td>Biaya Lain Lainnya</td>
							<td>:</td>
							<td>
								Rp 0
								<!-- {{
									numberWithCommas(
										this.otherCost
									)
								}} -->
							</td>
							<td>Derek</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.derek
										)
									)
								}}
							</td>
						</tr>
						<!-- <tr>
							<td colspan="3"></td>
							<td>Deskripsi Derek</td>
							<td>:</td>
							<td>{{estimationData.details.derek_desc}}</td>
						</tr> -->
						<!-- <tr>
							
							<td>PPh 23</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(this.estimationData.details.pph)
									)
								}}
								({{ 100 - pphPercentage }}%)
							</td>
						</tr> -->
						<tr>
							<td>Own Risk</td>
							<td>:</td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.own_risk
										)
									)
								}}
							</td>
							<template v-if="dp">
								<td>Down Payment</td>
								<td>:</td>
								<td>
									Rp
									{{
										numberWithCommas(
											parseFloat(
												dp.amount
											)
										)
									}}
								</td>
							</template>
							
						</tr>
						<!-- <tr style="font-weight:bold;border-bottom:1px solid black">
							<td colspan="3">Net Total</td>
							<td colspan="2"></td>
							<td>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details
												.totalAfterDisc
										)
									)
								}}
							</td>
						</tr> -->
						
					</table>

					<div v-else class="row border border-secondary rounded p-10">
						<!-- <div class="col-12 col-md-6 mt-1">
							<h5>Total Jasa</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.totalJasa
									)
								}}
							</p>
						</div> -->
						<div class="col-12 col-md-6 mt-1">
							<h5>Total Part</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.totalPart
									)
								}}
							</p>
						</div>
						<!-- <div class="col-12 col-md-6 mt-1">
							<h5>Diskon Jasa</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.discount
									)
								}}
							</p>
						</div> -->
						<div class="col-12 col-md-6 mt-1">
							<h5>Diskon Part</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										this.estimationData.details.discount_part
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Total Discount</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											this.estimationData.details.discount
										) +
											parseFloat(
												this.estimationData.details
													.discount_part
											)
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Biaya Lain Lainnya</h5>
							<p>
								Rp 0
								<!-- {{
									numberWithCommas(
										parseFloat(
											otherCost
										)
									)
								}} -->
							</p>
						</div>
						<div class="col-12"><hr /></div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Own Risk</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										estimationData.details.own_risk
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>Derek</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										estimationData.details.derek
									)
								}}
							</p>
						</div>
						<div class="col-12"><hr /></div>
						<div class="col-12 mt-1">
							<h5>Total Setelah Diskon</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										parseFloat(
											estimationData.details
												.totalAfterDisc -
												estimationData.details.ppn ? estimationData.details.ppn : 0
										)
									)
								}}
							</p>
						</div>
						<div class="col-12 col-md-6 mt-1">
							<h5>PPN</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										estimationData.details.ppn ? estimationData.details.ppn : 0
									)
								}}
							</p>
						</div>
						<!-- <div class="col-12 col-md-6 mt-1">
							<h5>PPh 23</h5>
							<p>
								Rp
								{{
									numberWithCommas(
										parseFloat(estimationData.details.pph)
									)
								}}
								({{ 100 - pphPercentage }}%)
							</p>
						</div> -->
					</div>
					
				</div>
				
			</div>
		</b-card>

		<b-card no-body class="mt-3" v-if="estimationData">
			<div class=" pt-2 text-center mt-2 mb-2 row ml-3 mr-3">
				<div class="col-6 text-left">
					<h4>Net Total</h4>
				</div>
				<div class="col-6 text-right">
					<h4>Rp {{ calculateTotal(1) }}.00</h4>
				</div>
				<!-- <button
					class="btn btn-outline-secondary"
					:class="{'w-25' : !this.isMobile() , 'w-100' : this.isMobile()}"
					@click="showPricingDetail = 1"
				>
					Tampilkan Detail Harga
				</button> -->
			</div>
		</b-card>
        
        <!-- Pricing Done -->

        <div class="row mt-3">
            <div class="col">
                <button class="w-100 btn btn-primary" @click="showInsertModal('Discount', 'discount')">Atur Diskon</button>
            </div>
            <div class="col">
                <button class="w-100 btn btn-primary" @click="print = true">Print Estimasi</button>
            </div>
			<div class="col">
                <button class="w-100 btn btn-primary" @click="modal.printPoModal = true">Print PO</button>
            </div>
        </div>

        <selectSupplierModal
			v-if="supplierSparepartPriceList"
			:showData="supplierSparepartPriceList"
			@submit="updatePriceEstimation"
			@closeModal="supplierSparepartPriceList = null;"
			@updateEstimation="loadEstimation"
		/>

        <DerekOwnRiskDiscountModal
			v-if="insertModal"
			@closeModal="insertModal = false"
			@updateTable="getWoDetails"
			:data="Object.assign({}, estimationData.details)"
			:type="insertModalType"
			:variable="insertModalVar"
			:form_code="formCode"
            :partOnly="true"
		></DerekOwnRiskDiscountModal>

        <PrintEstimasi
			v-if="print"
			@closeModal="print = false"
			:data="estimationData"
			:form_code="formCode"
			:woDetail="woDetail"
			:total="calculateTotal(0)"
			:discount="estimationData.details.discount"
			:insuranceDetails="null"
			:discount_part="estimationData.details.discount_part"
			:dp="0"
            :partOnly="true"
		/>

		<PrintPO
			v-if="modal.printPoModal == true"
			@closeModal="modal.printPoModal = false"
			:data="
				estimationData.estimations.filter(
					(x) => x.sparepart_type == 'P'
				)
			"
			:dataSupplierPriceList="supplierPriceList"
			:workOrderDetail="woDetail"
			:form_code="formCode"
			@loadEstimation="loadEstimation"
		/>

		<adminAuth
			v-if="modal.showAdminAuth"
			@closeModal="modal.showAdminAuth = false"
			:reason="reason"
			:request="`Cancel Work Order : ${formCode}`"
			@approved="allowCancelWorkOrder"
			@token="cancelWorkOrder"
		/> 
    </div>
</template>

<script>
import moment from 'moment'
import individualRowEstimation from './../EstimatorApplication/children/individualRowEstimation.vue'
import selectSupplierModal from './../EstimatorApplication/children/selectSupplierModal.vue'
import DerekOwnRiskDiscountModal from './../EstimatorApplication/children/DerekOwnRiskDiscountModal.vue'
import PrintEstimasi from './../EstimatorApplication/children/PrintEstimasi.vue'
import PrintPO from './../EstimatorApplication/children/PrintPO.vue'
import adminAuth from '@/components/modal/adminAuthorization.vue'

export default {
    components : {
        individualRowEstimation,
        selectSupplierModal,
        DerekOwnRiskDiscountModal,
        PrintEstimasi,
		PrintPO,
		adminAuth
    },
    data () {
        return {
            woDetail : null,
            woFull : null,
            formCode : this.$route.params.id,
            estimationData : null,
			modal : {
				printPoModal : false,
				showAdminAuth : false
			},
            model: {
				sparePart: {
					amount: 0,
					estimation_work_order_id: 0,
					sparepart_id: null,
					sparepart_size: null,
					attachment_id: null,
					insurance_car_type_id: null,
					insurance_company_id: null,
					without_ppn: false,
					type: null,
					extension : ''
				},
			},
			reason : '',
            showNegoInput : [],
            mobile : this.isMobile(),
            supplierPriceList : null,
            showPricingDetail : false,
            otherCost : 0,
            supplierSparepartPriceList : null,
            // Derek own risk Discount Modal
            insertModalType : null,
            insertModalVar : null,
            insertModal : false,
            // Print Estimasi
            print : false
        }
    },
    mounted () {
        this.getWoDetails()
        this.getWoOtherCost()
    },
    methods : {
		allowCancelWorkOrder(token, prevToken) {
			this.modal.showAdminAuth = false;

			if (token) {
				this.$http.defaults.headers.common["Authorization"] = prevToken;
			}

			this.$http
				.delete("/api/v1/workorder/" + this.formCode)
				.then(resp => {
					if (token)
						this.$store.dispatch("triggerAlert", [
							true,
							"Admin Permission Success. Work Order " +
								this.formCode +
								" Successfully Deleted"
						]);
					else
						this.$store.dispatch("triggerAlert", [
							true,
							"Work Order " +
								this.formCode +
								" Successfully Deleted"
						]);

					this.$router.push({ name: "WorkOrderForm" });
				})
				.catch(err => {
					this.$store.dispatch("triggerAlert", [
						false,
						"Oops Something Went Wrong. Please Try Again Later."
					]);
					console.log(err);
				});
		},
		cancelWorkOrder(token = null) {
			let prevToken = "";

			if (token) {
				prevToken = this.$http.defaults.headers.common["Authorization"];

				this.$http.defaults.headers.common["Authorization"] =
					"Bearer " + token;
			}

			this.$http
				.get("/api/v1/check")
				.then(resp => {
					let data = resp.data.data;
					let super_user = data.is_superuser;

					if (super_user) {
						this.allowCancelWorkOrder(token, prevToken);
					} else {
						this.modal.showAdminAuth = true;
						this.reason = token
							? "Akun tersebut tidak punya access untuk fitur ini. Mohon dicoba dengan Akun lainnya."
							: "Fitur tersebut hanya bisa dipakai pada 2 Jam Pertama Setelah Pembikinan Work Order Atau Otorisasi Admin.";
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
        getWoOtherCost () {
			this.$http.get('/api/v1/workorder-estimation/' + this.formCode + '/other-cost')
			.then((resp) => {
				let data = resp.data.data
				console.log(data)

				let otherCost = 0

				data.forEach(row => {
					otherCost += row.price
				})

				this.otherCost = otherCost
				// for(var i = 0 ; i < data.length ; i++) {
				// 	let model = JSON.parse(JSON.stringify(this.modelExtraCost))
				// 	model.description = data[i].description
				// 	model.amount = data[i].price
				// 	model.id = data[i].id
				// 	this.form.extraCost.push(model)
				// }

				
				
			})
			.catch((err) => {
				console.log(err)
			})
		},
        showInsertModal(name, variable) {
			// console.log(name)
			this.insertModalType = name;
			this.insertModalVar = variable;
			this.insertModal = true;
		},
        addNewSparePart() {
			this.newEstimationData = Object.assign({}, this.model.sparePart);
			this.newEstimationData.estimation_work_order_id = this.estimationData.details.id;
			this.$router.push({ 
				name : 'EstimatorAddSparepart',
				query : {
					// insurancePriceList : JSON.stringify(this.insurancePriceList),
					data : JSON.stringify(this.newEstimationData),
                    type : 'PartsOnly',
					// form : JSON.stringify(this.form),
					form_code : this.formCode,
                    approveInstant : true
				}
			})
		},
        calculateTotal(ppn) {
			// console.log(this.estimationData.details)

			let priceAfterDiscountJasa =
				this.estimationData.details.totalJasa -
				this.estimationData.details.discount;
			let priceAfterDiscountPart =
				this.estimationData.details.totalPart -
				this.estimationData.details.discount_part;
			this.estimationData.details.totalAfterDisc =
				priceAfterDiscountJasa +
				priceAfterDiscountPart - this.otherCost;
				// parseFloat(this.estimationData.details.derek) -
				// parseFloat(this.estimationData.details.own_risk);

			console.log(priceAfterDiscountJasa + priceAfterDiscountPart - 300000 - 15000 + this.estimationData.details.ppn);
			if (ppn)
				this.estimationData.details.totalAfterDisc += this.estimationData.details.ppn ? this.estimationData.details.ppn : 0;

			// alert(this.estimationData.details.totalAfterDisc)
			this.estimationData.details.pph = 0
			// 	((100 - ) / 100) *
			// 	0.02 *
			// 	priceAfterDiscountJasa;

			

			let total =
				this.estimationData.details.totalAfterDisc - (this.dp ? parseFloat(this.dp.amount) : 0);


			return this.numberWithCommas(total.toFixed(0));
		},
        getSupplierPrice() {
			this.$http
				.get("/api/v1/estimations-supplier/" + this.formCode)
				.then((resp) => {
					let priceSupplier = resp.data.data;
					this.supplierPriceList = {};

					for (
						var i = 0;
						i < this.estimationData.estimations.length;
						i++
					) {
						// let estimations = this.estimationData.estimations.find(x => x.sparepart_id == priceSupplier[i].sparepart_id)
						// estimations.supplierPriceList = estimations.supplier_prices
						let supplierPriceList = priceSupplier.find(
							(x) =>
								x.estimations_id ==
								this.estimationData.estimations[i].id
						);
						this.supplierPriceList[
							this.estimationData.estimations[i].id
						] = supplierPriceList
							? supplierPriceList
							: { supplier_prices: [] };
						console.log(this.supplierPriceList)
					}
				})
				.catch((err) => {
					console.log(err);
				});
		},
        async getWoDetails() {
            try {
                let response = await this.$http.get(`/api/v1/workorder/${this.formCode}/detail`)
                // console.log(response)
                let data = response.data.data

                let obj = {
                    customer : data.customer
                }

                this.woDetail = obj
                this.woFull = data

                this.loadEstimation()
            }
            catch(err) {
                console.log(err)
                this.$store.dispatch('triggerAlert' , [false , err , 'Something Went Wrong. Please Try Again Later.'])
            }
        },
        async getPurchaseOrderDetails() {
			let result = await this.$http.get(
				"/api/v1/purchase-order/" + this.formCode
			);

			return result.data.data;
		},
        async loadEstimation () {
            try {
                let response = await this.$http.get("/api/v1/workorder-estimation/" +
                    this.formCode +
                    "?showDeleted=true")
                // console.log(response.data.dataxz)
                this.estimationData = response.data.data;
                let estimationList = this.estimationData.estimations;
                let ppnPercentage = this.estimationData.ppn

                let ppnTotal = 0;
                let listOfPO = await this.getPurchaseOrderDetails();
				console.log(listOfPO)

                let temp = JSON.parse(JSON.stringify(estimationList));

                let orderedDates = temp.sort(function(a, b) {
                    // Turn your strings into dates, and then subtract them
                    // to get a value that is either negative, positive, or zero.
                    return new Date(a.created_at) - new Date(b.created_at);
                });

                this.curr_date = orderedDates[0]
                    ? moment(orderedDates[0].created_at).format("Y-MM-DD")
                    : moment().format("Y-MM-DD");

                this.totalSparepartPurchasePrice = 0;
                this.estimationData.details.totalJasa += this.estimationData.details.notApprovedJasa
                this.estimationData.details.totalPart += this.estimationData.details.notApprovedPart

                this.totalJasa = this.estimationData.details.totalJasa
                this.totalPart = this.estimationData.details.totalPart

                let derekList = this.estimationData.details.derekData.map(x => parseFloat(x.amount))
                
                const reducer = (accumulator, curr) => accumulator + curr;

                this.estimationData.details.derek = derekList.length > 0 ? derekList.reduce(reducer) : 0

                let discountMultJasa = parseFloat(this.estimationData.details.discount) / this.totalJasa
                let discountMultPart = parseFloat(this.estimationData.details.discount_part) / this.totalPart
                

                let discountPPN = parseFloat(this.estimationData.details.discount) + parseFloat(this.estimationData.details.discount_part)
                

                for (var i = 0; i < estimationList.length; i++) {
                    let discountMult = estimationList[i].sparepart_type == 'J' ? discountMultJasa : discountMultPart
                    let deductible = (parseFloat(estimationList[i].price_per_item) * parseFloat(estimationList[i].amount) * discountMult)
                    this.showNegoInput[i] = false;

                    if (estimationList[i].deleted_at != null) continue;

                    if (estimationList[i].sparepart_type == "P") {
                        let poDetails = listOfPO.find(
                            (x) =>
                                x.estimation_id == estimationList[i].id &&
                                !x.next_purchase_order_item
                        );
						console.log(poDetails + 'poDetails')
                        if (poDetails) {
                            estimationList[i].is_po = true;
                            estimationList[i].is_used = poDetails.is_used;
                            estimationList[i].is_arrived =
                                poDetails.is_arrived;
                            estimationList[i].time =
                                poDetails.time_of_arrival;

                            estimationList[i].is_used_date = poDetails.is_used_date
							
                        } else {
                            estimationList[i].is_po = false;
                        }
                    }

                    if(!estimationList[i].price_per_item && estimationList[i].estimated_price){
                        estimationList[i].price_per_item = estimationList[i].estimated_price
						estimationList[i].flag_estimated = true
                        continue;
                    }
                        

                    else if (!estimationList[i].price_per_item) continue;

					// if(estimationList[i].markup == 0) estimationList[i].price_per_item = 0;
					if(estimationList[i].sparepart_type == 'P' && !estimationList[i].markup){
						estimationList[i].price_modal = estimationList[i].price_per_item
						estimationList[i].price_per_item = estimationList[i].estimated_price ? estimationList[i].estimated_price : 0
						
						// estimationList[i].markup = 0
						continue;
					}


                    if( typeof estimationList[i].is_approved_by_insurance == 'number' && estimationList[i].is_approved_by_insurance == 0 ) continue;

                    if (
                        estimationList[i].is_approved_by_insurance &&
                        !estimationList[i].is_supplied_by_insurance &&
                        estimationList[i].sparepart_type == "P"
                    ) {
                        this.totalSparepartPurchasePrice += parseFloat(
                            estimationList[i].price_per_item
                        );
                    }

                    console.log(estimationList[i].markup + 'markup' + estimationList[i].part_number + estimationList[i].price_per_item)

                    

                    // if(estimationList[i].is_approved_by_insurance == 1 && !estimationList[i].is_supplied_by_insurance) {
                    let ppn = estimationList[i].ppn_included;

                    // let supplierPrice = this.supplierPriceList[estimationList[i].id].supplier_prices.find(x => x.id == estimationList[i].supplier_price_id)
                    let without_ppn = estimationList[i].without_ppn;
                    estimationList[i].price_per_item = parseFloat(estimationList[i].price_per_item) 

                    if (ppn == 1 && !without_ppn && estimationList[i].sparepart_type == 'J') {
                        estimationList[i].price_per_item = parseFloat(
                            estimationList[i].price_per_item / (1 + ppnPercentage)
                        );

                        estimationList[i].individual_ppn = (parseFloat(estimationList[i].price_per_item) *
                            parseFloat(estimationList[i].amount) - deductible) *
                            ppnPercentage;

                        

                        ppnTotal +=  estimationList[i].individual_ppn ? estimationList[i].individual_ppn : 0
                    }
                    else if (estimationList[i].sparepart_type == 'J' && ppn == 0 && !without_ppn) {
                        estimationList[i].individual_ppn = (parseFloat(estimationList[i].price_per_item) *
                            parseFloat(estimationList[i].amount) - deductible) *
                            ppnPercentage;

                        
                        ppnTotal +=  estimationList[i].individual_ppn ? estimationList[i].individual_ppn : 0

                    }

                    if(estimationList[i].ppn) {
                        
                        estimationList[i].individual_ppn = (estimationList[i].price_per_item  + parseFloat(estimationList[i].markup))* (1 - discountMult) * ppnPercentage
                        console.log(estimationList[i].individual_ppn)

                        ppnTotal +=  estimationList[i].individual_ppn ? estimationList[i].individual_ppn : 0 * parseFloat(estimationList[i].amount)
                    }
                    

                    if(without_ppn) {
                        discountPPN = discountPPN - deductible
                    }




                }

                // alert(discountPPN)
                if (ppnTotal != 0)
                    ppnTotal = Math.max(
                        0,
                        ppnTotal
                    );
                this.estimationData.details.ppn = ppnTotal;
                this.getSupplierPrice()
            }
            catch(err) {
                console.log(err)
                this.$store.dispatch('triggerAlert' , [false , err , 'Something Went Wrong. Please Try Again Later.'])
            }
        },
        showPriceModal(type, obj, index, id) {
			this.supplierSparepartPriceList = {
				priceList: obj,
				index: index,
				id: id,
				type: type,
			};
		},
    }
}
</script>

<style scoped>
.wo-stats th {
	font-size: 16px;
}
.wo-stats td {
	padding-left: 20px;
}

.table td {
	border-top: 0px solid black;
}
</style>